import "./index.scss";

export const CheckoutButton = ({ isCartLoading, affiliateUrl }) => {
  return (
    <a
      data-testid="review-cart-button"
      data-logid="review-and-checkout-cart-menu-button"
      data-gtm="true"
      href="/cart"
      target={affiliateUrl ? "_blank" : ""}
      tabIndex={0}
      onClick={
        isCartLoading
          ? () => {}
          : () => {
              // To allow the event to open new tab first
              setTimeout(() => {
                affiliateUrl && window.location.assign(affiliateUrl);
              }, 100);
            }
      }
      className={"checkout-button"}
    >
      REVIEW AND CHECKOUT
    </a>
  );
};
